import { render, staticRenderFns } from "./ReAllocationDialog.vue?vue&type=template&id=149c2879&scoped=true&lang=pug&"
import script from "./ReAllocationDialog.vue?vue&type=script&lang=ts&"
export * from "./ReAllocationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ReAllocationDialog.vue?vue&type=style&index=0&id=149c2879&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149c2879",
  null
  
)

export default component.exports